/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resendconfirmationemail2Inputs */

const en_resendconfirmationemail2 = /** @type {(inputs: Resendconfirmationemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend Confirmation Email`)
};

const de_resendconfirmationemail2 = /** @type {(inputs: Resendconfirmationemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungs-E-Mail erneut senden`)
};

/**
* | output |
* | --- |
* | "Resend Confirmation Email" |
*
* @param {Resendconfirmationemail2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const resendconfirmationemail2 = /** @type {((inputs?: Resendconfirmationemail2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resendconfirmationemail2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resendconfirmationemail2(inputs)
	return de_resendconfirmationemail2(inputs)
});
export { resendconfirmationemail2 as "resendConfirmationEmail" }